/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum VoucherSoldTypes {
  NONE = 'none',
  EXPERIENCE = 'experience',
  MONETARY = 'monetary',
  BOTH = 'both',
}
